declare const AUTH_SETTINGS: { customerId: string } | undefined;

const COOKIE_NAME = 'AlgoliaProductQueries';

const setAlgoliaCookie = (name: string, value: string, hours: number) => {
  const date = new Date();
  date.setTime(date.getTime() + hours * 60 * 60 * 1000);
  const expires = '; expires=' + date.toUTCString();
  document.cookie = name + '=' + (value || '') + expires + '; path=/';
};

const getAlgoliaCookie = (name: string): string | null => {
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

export const setQueryId = (queryId: string) => {
  setAlgoliaCookie('algolia-queryId', queryId, 1);
};

export const getQueryId = (): string | null => {
  return getAlgoliaCookie('algolia-queryId');
};

export const setBasketAddition = () => {
  localStorage.setItem('basketAddition', 'true');
};

export const getAuthUserToken = (): string =>
  typeof AUTH_SETTINGS !== 'undefined' ? AUTH_SETTINGS.customerId : '';

export const addProductAndQueryToCookie = (
  productCode: string,
  queryId: string,
) => {
  const raw = getAlgoliaCookie(COOKIE_NAME);
  // Cookie value is URL-encoded to avoid ASP.NET Core cookie parsing issues
  // with unescaped JSON characters ([, {, ", etc.)
  const decoded = raw ? decodeURIComponent(raw) : null;
  let products: Array<{ productCode: string; queryId: string }>;

  try {
    const parsed = decoded ? JSON.parse(decoded) : [];
    products = Array.isArray(parsed) ? parsed : [];
  } catch {
    products = [];
  }

  const existingIndex = products.findIndex(
    x => x.productCode === productCode,
  );

  if (existingIndex === -1) {
    products.push({ productCode, queryId });
  } else {
    products[existingIndex] = { productCode, queryId };
  }

  setAlgoliaCookie(COOKIE_NAME, encodeURIComponent(JSON.stringify(products)), 24);
};
